// Angular imports
import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
// Service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';
import { WFESpecialHandlingResultDto } from '../../shared-workflow-module/_models/wfe-special-handling-result-dto';
import { WorkflowHistoryResultDto } from '../../shared-workflow-module/_models/wfe-workflow-history-result-dto';
import { WorkFlowWorkOrderResultDto } from '../_models/common/wf-work-order-result-dto';
import { WFEVendorResultDto } from '../../shared-workflow-module/_models/wfe-vendor-result-dto';
import { WFEOwnerResultDto } from '../../shared-workflow-module/_models/wfe-owner-result-dto';
// constant imports
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from './../../_constants/cache-duration';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../_services/shared-services/mp-cache-registration-service";
export class WorkflowService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
    }
    getSpecialHandling(baseParams) {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}specialhandling${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(WFESpecialHandlingResultDto, response)));
    }
    updateSpecialHandling(baseParams) {
        return this.httpClient
            .put(`${URLConstants.ccWorkflowViewerBaseApiUrl}specialhandling`, classToPlain(baseParams))
            .pipe(map((responseData) => responseData.toString()));
    }
    toggleWorkFlowPaymentMethod(baseParams) {
        return this.httpClient
            .put(`${URLConstants.ccWorkflowViewerBaseApiUrl}togglepaymentmethod`, classToPlain(baseParams))
            .pipe(map((responseData) => responseData.toString()));
    }
    updateToReturnToAccountant(baseParams) {
        return this.httpClient
            .put(`${URLConstants.ccWorkflowViewerBaseApiUrl}returnToAccountant`, classToPlain(baseParams))
            .pipe(map((responseData) => responseData.toString()));
    }
    updateReverseAPBill(baseParams) {
        return this.httpClient
            .put(`${URLConstants.ccWorkflowViewerBaseApiUrl}reverse`, classToPlain(baseParams))
            .pipe(map((responseData) => responseData.toString()));
    }
    getViewDeleteReason(baseParam) {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}deletereason${baseParam.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParam.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient.get(url, options).pipe(map((response) => response.toString()));
    }
    getBoardHistory(baseParam) {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}board/history${baseParam.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParam.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(WorkflowHistoryResultDto, response)));
    }
    getVendors(baseParam) {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}vendors${baseParam.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParam.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(WFEVendorResultDto, response)));
    }
    getOwners(baseParam) {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}owners${baseParam.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParam.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(WFEOwnerResultDto, response)));
    }
    getOpenWorkOrders(baseParams) {
        const url = `${URLConstants.ccWorkOrderConfigApiUrl}/open${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(WorkFlowWorkOrderResultDto, response)));
    }
    manageWorkOrders(baseParams) {
        return this.httpClient
            .post(`${URLConstants.ccWorkflowViewerBaseApiUrl}workorders/manage`, classToPlain(baseParams))
            .pipe(map((responseData) => responseData));
    }
}
WorkflowService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WorkflowService_Factory() { return new WorkflowService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: WorkflowService, providedIn: "root" });
